import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './BookingPage.css';

const BookingPage = () => {
  const [formData, setFormData] = useState({
    serviceId: '',
    name: '',
    phone: '',
    address: '',
    date: '',
    time: '',
    notes: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const timeSlots = [
    '09:00-12:00',
    '13:00-16:00',
    '16:00-19:00',
    '19:00-22:00'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // 这里应该调用API提交预约信息
      console.log('提交预约信息:', formData);
      
      // 模拟API调用
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      alert('预约成功！我们会尽快与您联系确认服务时间。');
      
      // 重置表单
      setFormData({
        serviceId: '',
        name: '',
        phone: '',
        address: '',
        date: '',
        time: '',
        notes: ''
      });
    } catch (error) {
      console.error('预约失败:', error);
      alert('预约失败，请稍后重试。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="booking-page">
      <header className="booking-header">
  <Link to="/" className="back-btn">← 返回</Link>
        <h1>预约服务</h1>
      </header>

      <div className="container">
        <form onSubmit={handleSubmit} className="booking-form">
          <div className="form-group">
            <label htmlFor="name">姓名 *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              placeholder="请输入您的姓名"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">手机号 *</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
              placeholder="请输入您的手机号"
            />
          </div>

          <div className="form-group">
            <label htmlFor="address">服务地址 *</label>
            <textarea
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              required
              placeholder="请输入详细的服务地址"
              rows="3"
            />
          </div>

          <div className="form-group">
            <label htmlFor="date">服务日期 *</label>
            <input
              type="date"
              id="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
              required
              min={new Date().toISOString().split('T')[0]}
            />
          </div>

          <div className="form-group">
            <label htmlFor="time">服务时间 *</label>
            <select
              id="time"
              name="time"
              value={formData.time}
              onChange={handleInputChange}
              required
            >
              <option value="">请选择服务时间</option>
              {timeSlots.map(slot => (
                <option key={slot} value={slot}>{slot}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="notes">特殊要求</label>
            <textarea
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
              placeholder="如有特殊要求请在此说明"
              rows="3"
            />
          </div>

          <button 
            type="submit" 
            className="submit-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? '提交中...' : '确认预约'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BookingPage;
